export enum MimetypeEnum {

    Text = 'text/plain',

    ImageJpeg = 'image/jpeg',

}
